import * as Dashboard from './recruiting-dashboard.actions';
import * as DealsActions from './deals.actions';
import * as DealDetailsActions from './deal-details.actions';
import * as DirectOfferImportMarginActions from './direct-offer-import-margin.actions';
import * as CandidateDetailsActions from './candidate-details.actions';

export const RecruitingActions = {
    Dashboard,
    DealsActions,
    DealDetailsActions,
    DirectOfferImportMarginActions,
    CandidateDetailsActions
};
